import Axios from '@/axios'

// 用户登录
export const userSignIn = data => {
  return Axios({
    url: '/face/web/users/login',
    method: 'POST',
    type: 'json',
    data
  })
}
// 用户登出
export const userSignOut = data => {
  return Axios({
    url: '/face/web/users/logout',
    method: 'POST',
    type: 'json',
    data
  })
}
// 验证验证码正确与否
export const validateVerifyCode = params => {
  return Axios({
    url: '/face/web/users/validate_verification_codes',
    method: 'GET',
    type: 'json',
    params
  })
}
// 用户注册
export const userRegister = data => {
  return Axios({
    url: '/face/web/users/create_user',
    method: 'POST',
    type: 'json',
    data
  })
}
// 发送创建用户验证码
export const sendRegisterPhoneCode = data => {
  console.log(data)
  return Axios({
    url: '/face/web/users/create_sms_token',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改用户信息
export const modifyUserInfo = data => {
  return Axios({
    url: '/face/web/users/update_user',
    method: 'PUT',
    type: 'json',
    data
  })
}
// 发送修改用户信息验证码
export const sendModifyPhoneCode = data => {
  return Axios({
    url: '/face/web/users/update_sms_token',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改用户密码
export const changePassword = data => {
  return Axios({
    url: '/face/web/users/change_password',
    method: 'POST',
    type: 'json',
    data
  })
}
// 发送修改用户密码验证码
export const sendChangePasswordPhoneCode = (params, data) => {
  return Axios({
    url: `/face/web/users/change_password_sms_token`,
    method: 'POST',
    type: 'json',
    params,
    data
  })
}
// 验证新密码是否和旧密码一致
export const isSameWithOldPasswoed = params => {
  return Axios({
    url: '/face/web/users/is_password_same',
    method: 'GET',
    type: 'json',
    params
  })
}
// 根据用户名获取用户信息
export const getUserInfoByName = params => {
  return Axios({
    url: '/face/web/users/get_login_name',
    method: 'GET',
    type: 'json',
    params
  })
}
// 查询用户配置
export const getUserConfig = params => {
  return Axios({
    url: '/face/web/users/show_user_config',
    method: 'GET',
    type: 'json',
    params
  })
}
// 设置用户配置
export const setUserConfig = data => {
  return Axios({
    url: '/face/web/users/update_user_config',
    method: 'POST',
    type: 'json',
    data
  })
}

// 眼镜设备用户加入公司二维码
export const getGlassesQRCode = data => {
  return Axios({
    url: '/face/web/users/face_lib_device_user_join_code',
    method: 'GET',
    type: 'json',
    data
  })
}

// 同步所有数据到眼镜后台
export const syncDataToClassesDB = data => {
  return Axios({
    url: '/face/web/users/face_lib_trans_all',
    method: 'POST',
    type: 'json',
    data
  })
}

// 同步所有数据到眼镜后台
export const indexUserServiceChangeLog = data => {
  return Axios({
    url: '/face/web/users/index_user_billing_service_change_log',
    method: 'POST',
    type: 'json',
    data
  })
}
